// Combined translation and icon mapping in a single object
const professionTranslations = {
  'PELAJAR': { name: 'Student', icon: 'pelajar' },
  'PERTANIAN': { name: 'Agriculture', icon: 'pertanian' },
  'BELUM_TIDA': { name: 'Unemployed', icon: 'belumBekerja' },
  'ASN_PNS': { name: 'Civil Servant', icon: 'asnPns' },
  'KEAGAMAAN': { name: 'Religion', icon: 'religion' },
  'KESEHATAN': { name: 'Healthcare', icon: 'kesehatan' },
  'PENDIDIKAN': { name: 'Education', icon: 'pendidikan' },
  'PENSIUNAN': { name: 'Retired', icon: 'pensiunan' },
  'LAINNYA': { name: 'Others', icon: 'others' },
  'NELAYAN': { name: 'Fisherman', icon: 'nelayan' },
  'WIRASWASTA': { name: 'Entrepreneur', icon: 'wiraswasta' },
  'PILOT': { name: 'Pilot', icon: 'pilot' },
  'DOKTER': { name: 'Doctor', icon: 'doctor' },
  'SENIMAN': { name: 'Artist', icon: 'artist' },
  'KONSULTAN': { name: 'Consultant', icon: 'consultan' },
  'DRIVER': { name: 'Driver', icon: 'driver' },
  'PENGACARA': { name: 'Lawyer', icon: 'lawyer' },
  'PEKERJA': { name: 'Worker', icon: 'worker' },
  'PERIKANAN': { name: 'Fishery', icon: 'fishery' },
};

// Single function to get both name and icon
const getProfessionDetails = (key) => professionTranslations[key] || { name: key, icon: 'others' };

/**
 * @param {{[key:string]: number}} profession
 */
export const professionMappers = (profession) => {
  if (!profession) {
    return { topSix: undefined, other: undefined };
  }

  const sortedProfessions = Object.entries(profession)
    .sort(([, a], [, b]) => b - a)
    .map(([key, total], idx) => ({
      order: idx + 1,
      ...getProfessionDetails(key),
      total,
    }));

  return {
    topSix: sortedProfessions.slice(0, 6),
    other: sortedProfessions.slice(6),
  };
};
